import { AgencyDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/AgencyDashboard/store/agencyDashboard.store.types';

export const AGENCY_DATA_LOCKED_STUB: Partial<AgencyDashboardStore> = {
  totalHours: 892,
  totalHoursPeriodDays: 7,
  totalHoursChangePrct: 9,
  totalShifts: 104,
  totalShiftsPeriodDays: 7,
  totalShiftsChangePrct: 7,
  sentToAgencyRate: 6,
  sentToAgencyRatePeriodDays: 7,
  sentToAgencyRateChangePrct: 0.6,
  shiftsByPosition: [
    { positionId: '17', position: 'Resident Care Partner (PSW)', shiftCount: 41, hours: 352 },
    { positionId: '18', position: 'Wellness Nurse', shiftCount: 26, hours: 238 },
    { positionId: '19', position: 'Medication Care Partner', shiftCount: 21, hours: 168 },
    { positionId: '20', position: 'Housekeeper', shiftCount: 16, hours: 134 },
  ],
  hoursDistribution: [
    { bucketStart: '2026-05-06 Mon', hours: 28, sentToAgencyRate: 3.8 },
    { bucketStart: '2026-05-07 Tue', hours: 34, sentToAgencyRate: 4.6 },
    { bucketStart: '2026-05-08 Wed', hours: 31, sentToAgencyRate: 4.2 },
    { bucketStart: '2026-05-09 Thu', hours: 40, sentToAgencyRate: 5.4 },
    { bucketStart: '2026-05-10 Fri', hours: 44, sentToAgencyRate: 5.9 },
    { bucketStart: '2026-05-11 Sat', hours: 52, sentToAgencyRate: 7 },
    { bucketStart: '2026-05-12 Sun', hours: 49, sentToAgencyRate: 6.6 },
  ],
  hoursByProvider: [
    { providerId: '91', provider: 'Bayshore HealthCare', shiftCount: 33, hours: 288 },
    { providerId: '92', provider: 'ParaMed', shiftCount: 24, hours: 214 },
    { providerId: '93', provider: 'Nursefinders', shiftCount: 20, hours: 168 },
    { providerId: '94', provider: 'CarePro Staffing', shiftCount: 15, hours: 132 },
    { providerId: '95', provider: 'StaffAid', shiftCount: 12, hours: 90 },
  ],
  leadTime: [
    { key: 'under_4h', label: '< 4h (last minute)', count: 31, percentage: 30 },
    { key: '4_to_12h', label: '4 – 12h', count: 24, percentage: 23 },
    { key: '12_to_24h', label: '12 – 24h', count: 22, percentage: 21 },
    { key: '1_to_3_days', label: '1 – 3 days', count: 18, percentage: 17 },
    { key: '3_to_7_days', label: '3 – 7 days', count: 7, percentage: 7 },
    { key: 'over_7_days', label: '> 7 days', count: 2, percentage: 2 },
  ],
  shiftsByTimeframe: [
    { timeframe: 'Morning', dayOfWeek: 'Mon', shiftCount: 4 },
    { timeframe: 'Morning', dayOfWeek: 'Tue', shiftCount: 3 },
    { timeframe: 'Morning', dayOfWeek: 'Wed', shiftCount: 4 },
    { timeframe: 'Morning', dayOfWeek: 'Thu', shiftCount: 5 },
    { timeframe: 'Morning', dayOfWeek: 'Fri', shiftCount: 6 },
    { timeframe: 'Morning', dayOfWeek: 'Sat', shiftCount: 7 },
    { timeframe: 'Morning', dayOfWeek: 'Sun', shiftCount: 6 },
    { timeframe: 'Evening', dayOfWeek: 'Mon', shiftCount: 3 },
    { timeframe: 'Evening', dayOfWeek: 'Tue', shiftCount: 3 },
    { timeframe: 'Evening', dayOfWeek: 'Wed', shiftCount: 4 },
    { timeframe: 'Evening', dayOfWeek: 'Thu', shiftCount: 4 },
    { timeframe: 'Evening', dayOfWeek: 'Fri', shiftCount: 5 },
    { timeframe: 'Evening', dayOfWeek: 'Sat', shiftCount: 7 },
    { timeframe: 'Evening', dayOfWeek: 'Sun', shiftCount: 6 },
    { timeframe: 'Overnight', dayOfWeek: 'Mon', shiftCount: 2 },
    { timeframe: 'Overnight', dayOfWeek: 'Tue', shiftCount: 2 },
    { timeframe: 'Overnight', dayOfWeek: 'Wed', shiftCount: 2 },
    { timeframe: 'Overnight', dayOfWeek: 'Thu', shiftCount: 3 },
    { timeframe: 'Overnight', dayOfWeek: 'Fri', shiftCount: 4 },
    { timeframe: 'Overnight', dayOfWeek: 'Sat', shiftCount: 5 },
    { timeframe: 'Overnight', dayOfWeek: 'Sun', shiftCount: 5 },
  ],
  shiftsSentByScheduler: [
    {
      schedulerId: '1',
      scheduler: 'Karen Whitfield',
      location: 'Seasons Amherstburg',
      shiftCount: 28,
      hours: 241,
      averageLeadHours: 6.2,
    },
    {
      schedulerId: '2',
      scheduler: 'Marcus Lee',
      location: 'Seasons Cambridge',
      shiftCount: 22,
      hours: 187,
      averageLeadHours: 11.4,
    },
    {
      schedulerId: '3',
      scheduler: 'Priya Nair',
      location: 'Seasons Owen Sound',
      shiftCount: 18,
      hours: 152,
      averageLeadHours: 4.1,
    },
    {
      schedulerId: '4',
      scheduler: 'Tom Becker',
      location: 'Seasons Belle River',
      shiftCount: 14,
      hours: 118,
      averageLeadHours: 18.6,
    },
    {
      schedulerId: '5',
      scheduler: 'Dana Klassen',
      location: 'Seasons Camrose',
      shiftCount: 12,
      hours: 104,
      averageLeadHours: 9,
    },
  ],
};
